import styled from '@emotion/styled';

const StyledList = styled.ul`
  position: absolute;
  left: 0;
  top: 3.5rem;
  z-index: 50;
  margin: 0;
  padding: 0;
  width: 100%;
  max-height: 400px;
  overflow-y: auto;
  background-color: ${({ theme }) => theme.colors.neutral.white100};
  border: 0.125rem solid ${({ theme }) => theme.colors.neutral.grey80};
  border-radius: ${({ theme }) => theme.radius.sm};
  box-shadow:
    0 4px 6px -1px rgb(0 0 0 / 10%),
    0 2px 4px -2px rgb(0 0 0 / 10%);
  font-size: 1rem;
  line-height: 1.5;
  list-style-type: none;

  @media (max-height: 250px) {
    top: 2.75rem;
    max-height: 55vh;
  }

  @media (max-width: 319px) {
    top: 2.75rem;
    max-height: 60vh;
  }
`;

const ListItem = styled.li`
  &:not(:first-of-type) {
    border-top: 1px solid ${({ theme }) => theme.colors.neutral.grey80};
  }
`;

const StyledButton = styled.button`
  display: inline-grid;
  grid-template: auto / 1.5rem 1fr;
  gap: 0 0.5rem;
  align-items: center;
  margin: 0;
  padding: 0.75rem;
  border: 0;
  outline: 0;
  width: 100%;
  font: inherit;
  text-align: left;
  color: ${({ theme }) => theme.colors.neutral.grey160};
  background: none;
  cursor: pointer;

  @media (max-width: 319px) {
    display: block;
  }

  &:hover,
  &:focus-visible,
  &[aria-selected='true'] {
    color: ${({ theme }) => theme.colors.neutral.grey160};
    background-color: ${({ theme }) => theme.colors.brand.green20};
  }
`;

const IconWrapper = styled.span`
  grid-row: 1 / span 2;
  display: flex;

  @media (max-width: 319px) {
    display: none;
  }

  svg {
    fill: currentcolor;
  }
`;

const Price = styled.data`
  display: block;
  font-size: 0.875rem;
  color: ${({ theme }) => theme.colors.neutral.grey120};
`;

const ErrorMessage = styled.div`
  position: absolute;
  left: 0;
  top: 100%;
  width: 100%;
  margin-top: -1px; /* to align with the border */
  background-color: ${({ theme }) => theme.colors.neutral.white100};
  color: ${({ theme }) => theme.colors.accent.red100};
  border: 1px solid ${({ theme }) => theme.colors.accent.red100};
  border-radius: ${({ theme }) => theme.radius.sm};
  font-size: 0.875rem;
  line-height: 1.5;
  padding: 0.5rem 0.625rem;
  z-index: 3;
`;

export { ListItem, StyledList, StyledButton, Price, IconWrapper, ErrorMessage };
